import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';
import {ShowIf} from 'components/utils';
import {checkServerLive} from 'constants/config';
import fileDownload from 'js-file-download';
import {downloadFile} from 'components/utils';

export default class RowItemVideo extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          {this.props.item.ten}
        </td>
        <td>
          {this.props.item.danhMucVideoInfo ? this.props.item.danhMucVideoInfo.ten : ''}
        </td>
        <td>
          {this.props.item.loaiVideoInfo ? this.props.item.loaiVideoInfo.text : ''}
        </td>
        <td>
          <ShowIf condition={!checkServerLive}>
            <Link className="txt-blue txt-underline" onClick={fileDownload.bind(this, this.props.item.urlFileVideo, this.props.item.tenFileVideo)}>{this.props.item.tenFileVideo}</Link>
          </ShowIf>
          <ShowIf condition={checkServerLive}>
            <Link className="txt-blue txt-underline" onClick={() => {downloadFile(this.props.item.urlFileVideo, this.props.item.tenFileVideo)}}>{this.props.item.tenFileVideo}</Link>
          </ShowIf>
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('VIDEO_SUA') ?
                <Link className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)} >Chỉnh sửa</Link>
              : null
            }
            {
              CheckPermission('VIDEO_XOA') ?
                <DeleteDialog
                  title= {'Xoá danh mục'}
                  content= {'Bạn chắc chắn muốn xoá video này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.videoId}
                />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemVideo.jsx